import React from 'react';
import { useLocation } from 'react-router-dom';

import Header from '../components/shared/Header/Header';
import Footer from '../components/shared/Footer/Footer';
import VerboxChat from '../components/shared/VerboxChat/VerboxChat';

export function Layout({ children }) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isDevicesListPage = location.pathname === '/devices';
  const isDevicePage = /^\/devices\/[^/]+$/.test(location.pathname);

  return (
    <div className={`layout d-flex flex-column ${isDevicesListPage ? 'layout--devices-list' : 'min-vh-100'}`}>
      {!isHomePage && <Header route={`${location.pathname}${location.search}`}/>}
      <div className={`container flex-grow-1 layout__content ${isDevicesListPage ? 'layout__content--devices-list' : ''}`}>
        {children}
      </div>
      {!isHomePage &&  <Footer/>}
      {isDevicePage && <VerboxChat pathname={location.pathname} />}
     
    </div>
  );
}
